import { Brand } from "./Brand";

/** The admin console's "Maker portal ↗" opened this tab, and its one-time code is being spent: nothing to choose or sign. */
export function HandoffScreen() {
  return (
    <div className="signin-screen">
      <Brand name="AileFX Maker portal" sub="For market makers" />
      <section className="signin-card" aria-labelledby="handoff-title" aria-busy="true">
        <div className="signin-handoff" role="status">
          <svg width="20" height="20" viewBox="0 0 12 12" fill="none" strokeWidth="1.6" strokeLinecap="round" aria-hidden="true" className="signin-busy-spin">
            <circle cx="6" cy="6" r="4.5" stroke="#cfe6d6" />
            <path d="M6 1.5a4.5 4.5 0 0 1 4.5 4.5" stroke="#3f7a52" />
          </svg>
          <h1 id="handoff-title" className="signin-handoff-title">
            Signing you in from the admin console…
          </h1>
        </div>
      </section>
    </div>
  );
}
